import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  private config: Map<string, any>;

  constructor(private http: HttpClient) {
    this.config = new Map<string, string>([]);
    for (let [key, value] of Object.entries(environment)) {
      this.config.set(key, value);
    }
  }

  init(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.http.get('./assets/config.json').toPromise().then(data => {
        for (let [key, value] of Object.entries(data)) {
          if (this.config.has(key)) {
            continue;
          }
          this.config.set(key, value);
        }
        resolve();
      }).catch(err => reject(err));
    });
  }

  get<T extends any>(key: string): T {
    return this.config.get(key) as T;
  }
}
